import React from "react";
import { Alert, Form, Icon, Button, Select, Row, Col } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router";

import {
  postDelegationLogRequest,
  duplicateDelegationLogRequest,
} from "../../api/requests";

import {
  getDelegationLogAdminCreatePermission,
  getDelegationLogAdminUpdatePermission,
} from "../../reducers/user/selectors";

import { logout } from "../../reducers/user/actions";
import classes from "./DelegationLogs.css";
import { withParams } from "../../utils/url";
const routes = require("../../routes.json");

const { Option } = Select;

class AddDelegationLogForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });
        let id;

        try {
          if (this.props.duplicateLogId) {
            const { data } = await duplicateDelegationLogRequest({
              id: this.props.duplicateLogId,
              site_id: values.site_id,
            });

            id = data.id;
          } else {
            const { data } = await postDelegationLogRequest({
              site_id: values.site_id,
            });

            id = data.id;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            if (this.props.delegationLogAdminUpdatePermission) {
              this.props.history.push(
                withParams(routes.admin.delegationLog, { id })
              );

              window.location.reload();
            } else {
              this.props.onSubmit();
            }
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: JSON.stringify(get(e, "response.data.error", "Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { delegationLogAdminCreatePermission, sites } = this.props;

    const isEditable = delegationLogAdminCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceDelegationLogs:Add New Delegation log"
            )}
          </h4>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t("Site ID")}</b>
                <Form.Item>
                  {getFieldDecorator("site_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "site.id"),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select Site ID")}
                      style={{ width: "100%" }}
                      allowClear
                    >
                      {sites.map((site) => (
                        <Option key={site.id} value={site.id}>
                          {site.code} - {site.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={isLoading}
                className={classes.submitButton}
              >
                {this.props.i18n.t("Save")}
              </Button>
            )}
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminCreatePermission: getDelegationLogAdminCreatePermission(
    state
  ),
  delegationLogAdminUpdatePermission: getDelegationLogAdminUpdatePermission(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "AddDelegationLogForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(AddDelegationLogForm)))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/AddDelegationLogForm.js